import PropTypes from "prop-types";
import React from "react";

import { Button } from "../Button";
import { ButtonTypes } from "../constants";
import { createClassNameString } from "../utils";

import "./styles.scss";

export const Toast = ({
  children,
  className,
  dismissMessage,
  dismissTimeout,
  hideDismissButton,
  hideReportButton,
  messageType,
  onDismissButtonClick,
  onReportButtonClick,
  requestId,
  toastId,
  ...props
}) => {
  if (dismissTimeout) {
    setTimeout(() => {
      onDismissButtonClick({ toastId });
    }, dismissTimeout);
  }

  return (
    <div className={createClassNameString(["apti-Toast", className, messageType])} {...props}>
      <div className="apti-Toast__message-contents">
        {children}
        {requestId && <div>Request ID: {requestId}</div>}
      </div>
      <div className="apti-Toast__button-group">
        {!hideReportButton && (
          <Button
            buttonType={ButtonTypes.primary}
            className="apti-Toast__button"
            onClick={() => onReportButtonClick()}
          >
            Report
          </Button>
        )}
        {!hideDismissButton && (
          <Button
            buttonType={ButtonTypes.primary}
            className="apti-Toast__button"
            onClick={() => onDismissButtonClick({ toastId })}
          >
            {dismissMessage}
          </Button>
        )}
      </div>
    </div>
  );
};

Toast.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  className: PropTypes.string,
  dismissMessage: PropTypes.string,
  dismissTimeout: PropTypes.number,
  hideDismissButton: PropTypes.bool,
  hideReportButton: PropTypes.bool,
  messageType: PropTypes.oneOf(["success", "warning", "error", "error_v2", "success_v2"]),
  onReportButtonClick: PropTypes.func,
  requestId: PropTypes.string,
};

Toast.defaultProps = {
  className: undefined,
  dismissMessage: "Dismiss",
  dismissTimeout: 10000,
  hideDismissButton: false,
  hideReportButton: true,
  messageType: "success",
  onReportButtonClick: () => {
    console.log("button click not implemented");
  },
  requestId: undefined,
};
